import { halfDoughnutStore } from "./_components/half-doughnut/half-doughnut-store"
import { leakSeverityStore } from "./_components/leak-severity/leak-severity-store"
import { orgStore } from "./org-store"

export const orgLoader = async ({ params }) => {
  const { org } = params
  await Promise.all([
    orgStore.getState().getOrgReportSummary(org),
    orgStore.getState().getOrgReportRaw(org)
  ])

  const state = orgStore.getState()

  await Promise.all([
    halfDoughnutStore.getState().setCharts(state.overview),
    leakSeverityStore.getState().setChart(state.severityInfo)
  ])
}
